import React from "react";

import "./TopGallery.css";

import image1 from "../../../res/TopGallery/a.jpg";
import image2 from "../../../res/TopGallery/b.jpg";
import image3 from "../../../res/TopGallery/c.jpg";
import image4 from "../../../res/TopGallery/d.jpg";

export default class TopGallery extends React.Component
{
    render () {
        return (
            <div className="top-gallery is-hidden-sm">
                <img src={image1} />
                <img src={image2} />
                <img src={image3} />
                <img src={image4} />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/Layout/TopGallery.jsx